import React, { useContext } from 'react'
import styled from 'styled-components'
import PageLayout from '../../components/PageLayout'
import theme from '@shared/utils/theme'
import Icon from '@shared/components/Icon'
import { RecordContext } from './RecordPage'

const RecordSentContainer = styled(PageLayout)`
  color: ${ theme.palette.black };
  align-items: center;
  .content{
    justify-content: center;
  }
  .title svg {
    fill: ${ theme.palette.green };
    margin-right: 20px;
  }
  .title{
    font-size: 20px;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
  }
  .email{
    width: 32px;
    height: 32px;
    margin-bottom: 10px;
  }
  .text-bold{
    font-weight: bold;
  }
`

const RecordSent = ({ ...props }) => {

  const { parentHistory,record } = useContext(RecordContext)

  return (
    <RecordSentContainer
      actions={ {
        submitTxt: 'Retour à l’accueil',
        onSubmit: () => {
          parentHistory('/')
        }
      } }
    >
      <div className="title">
        <Icon name="email" className="email"/>
        <span>Votre dossier est envoyé</span>
      </div>
      <div>
        Dossier <span className="text-bold">n° { record.reference }</span>
      </div>
      <br/>
      <div>
        Vous allez recevoir un mail qui confirme votre dépôt de demande d’allocation.<br/>
        Vous pourrez suivre le statut de votre demande sur votre page d’accueil de Pimprenelle.
      </div>
    </RecordSentContainer>)
}

export default RecordSent
